<template>
  <div class="p-top-search">
    <div class="nomal">
      <slot name="nomal"></slot>
      <div class="searchitembtn">
        <el-button
          v-if="!ismore && ismoresearch == true"
          type="text"
          class="mr8 btn p-btn-textbott"
          @click="seemore()"
          >更多筛选</el-button
        >
        <el-button
          v-if="!ismore"
          class="btn"
          type="primary"
          plain
          @click="searchclick()"
          >搜索</el-button
        >
        <el-button v-if="!ismore" class="btn" @click="clear()">清空</el-button>
      </div>
      <slot name="morbtn"></slot>
    </div>
    <div class="clear"></div>
    <div v-show="ismore">
      <slot name="moresearch"></slot>
      <div class="searchitembtn">
        <el-button class="btn" type="primary" plain @click="searchclick()"
          >搜索</el-button
        >
        <el-button class="btn" @click="clear()">清空</el-button>
        <el-button class="btn" @click="close()">关闭</el-button>
      </div>
    </div>

    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: "P-topSearch",
  props: {
    ismoresearch: {
      //是否包含了更多搜索
      type: Boolean,
      default: false,
    },
    nomalsearch: {
      type: Object,
      default: () => ({}),
    },
    moresearch: {
      type: Object,
      default: () => ({}),
    },
    ismore: {
      type: Boolean,
      default: false,
    },
    customMoreSearch:{
      type: Boolean,
      default: false,
    }
    
  },
  components: {},
  data: function () {
    return {
      //ismore:false //是否显示更多搜索
    };
  },
  mounted: function () {},
  methods: {
    searchclick() {
      let that = this;
      let info = {
        ...that.nomalsearch,
      };
      if (that.ismore) {
        info = {
          ...that.nomalsearch,
          ...that.moresearch,
        };
      }
      that.$emit("searchclick", {
        ismore: that.ismore,
        info: info,
      });
    },
    clear() {
      let that = this;
      that.$emit("clear");
    },
    close() {
      let that = this;
      // 通过事件通知父组件更新 ismore 状态，而不是直接修改 prop
      that.$emit("changeIsMore", false);
    },
    seemore() {
      let that = this;
      //点击自定义的查看更多用户回调
      if(that.customMoreSearch){
        that.$emit('moreClick')
        return
      }
      // 通过事件通知父组件更新 ismore 状态，而不是直接修改 prop
      that.$emit("changeIsMore", true);
    },
    changeIsMore() {
      let that = this;
      that.$emit("changeIsMore", this.ismore);
    },
  },
};
</script>

<style>
</style>